import { EnvelopeOpenIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import { connect } from 'react-redux';
import { Actions as COMPANYACTIONS } from '../../store/actions/companyActions';

const BillingEmailRow = ({
    email,
    openBillingEmailModal
}) => {
    return (
        <tr>
            <td style={{textAlign: 'center'}}>
                {email?.email}
            </td>
            <td style={{textAlign: 'center'}}>
                {format(new Date(email?.date), 'do MMMM, yyyy')}
            </td>
            <td style={{textAlign: 'center'}}>
                {email?.attempt + 1}
            </td>
            <td style={{textAlign: 'center', width: "5%"}}>
                <button
                className="btn btn-xs btn-default mr-3"
                onClick={(e) => {openBillingEmailModal(email, true)}}>
                    <EnvelopeOpenIcon className="w-6 h-6 media-middle" />
                </button>
            </td>
        </tr>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = dispatch => ({
    openBillingEmailModal: (email, status) => dispatch(COMPANYACTIONS.openBillingEmailModal(email, status))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingEmailRow)